import { render, staticRenderFns } from "./form.vue?vue&type=template&id=5f22b7d1&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=5f22b7d1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22b7d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f22b7d1')) {
      api.createRecord('5f22b7d1', component.options)
    } else {
      api.reload('5f22b7d1', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=5f22b7d1&scoped=true", function () {
      api.rerender('5f22b7d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/locale/form.vue"
export default component.exports